// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"Menu_Overlay__3rUb-","OverlayHidden":"Menu_OverlayHidden__2MZBY"};